// Follow the pointer with a radial glow on any .glow-hover element
const $glowElements = document.querySelectorAll('.glow-hover');

$glowElements.forEach(($element) => {
    $element.addEventListener('pointermove', (event) => {
        const rect = $element.getBoundingClientRect();

        $element.style.setProperty('--glow-x', `${event.clientX - rect.left}px`);
        $element.style.setProperty('--glow-y', `${event.clientY - rect.top}px`);
    });
});
